import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class ApplyCreditInvoiceService extends ApiService {
  namespace = "apply-credit-invoice";
  icon = "Check";
  name = "Type";
  favicon = "CubeBlue";
  window = 290;
  Width = 920;
  realm = 2;
  DOMAIN = DOMAIN.CREDIT;
  preClosed = true;
  action = "actionApply";
  type = "type";
  singular = this.terminology.type.singular;
  plural = this.terminology.type.plural;
  vowel = this.terminology.type.vowel;

  constructor() {
    super("apply-credits");
  }
}
